module.exports = __webpack_public_path__ + "media/limitations/cielorazoinclinado-cecf6cf2.png";